import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DisposalCompletionDialogProps {
  readonly open: boolean;
  readonly onChoice: (viewTransactions: boolean) => void;
}

export function DisposalCompletionDialog({ open, onChoice }: DisposalCompletionDialogProps): React.ReactElement {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disposal Completed</AlertDialogTitle>
          <AlertDialogDescription>
            Do you want to view the transactions created in the Asset History screen, or stay on the Asset screen?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onChoice(false)}>
            Stay on Asset
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => onChoice(true)}>
            View Transactions
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
